import { FilterSwipeDialogCommonFilter } from './_CommonFilterList/FilterSwipeDialogCommonFilter';
import { FiltersSwipeDialogOptionList } from './_OptionList/FiltersSwipeDialogOptionList';
import { FiltersSwipeDialogDateRange } from './_DateRange/FiltersSwipeDialogDateRange';
import { TFilterType } from '../models';
import { FC } from 'react';
import { ISwipeDialogComponentProps } from './models';
import { FiltersSwipeDialogString } from './_String/FiltersSwipeDialogString';

type TPageConfig = Partial<{ [keyof in TFilterType]: FC<ISwipeDialogComponentProps> }> & {
  default: FC<ISwipeDialogComponentProps>;
};
export type TPageConfigKey = keyof TPageConfig;
/** Компоненты фильтров для которых нужно более детальное отображение при выборе, такие как опции, дата и т.д. */
export const PAGE_FILTER_TYPE_COMPONENTS: TPageConfig = {
  options: FiltersSwipeDialogOptionList,
  default: FilterSwipeDialogCommonFilter,
  dateRange: FiltersSwipeDialogDateRange,
  string: FiltersSwipeDialogString,
};
